export const shopModule = {
    namespaced: true,
    state: {
        view: "cart",
        cart: [],
        customerId: null,
        cartTotal: 0,
        shippingCost: 0,
        orderID: null,
    },
    getters: {
        totalAmount: (state) => {
            let amount = 0;
            state.cart.forEach((item) => (amount += item.price * item.quantity));
            amount += state.shippingCost;
            return amount;
        },
    },
    mutations: {
        addToCart({ cart }, product) {
            const itemIndex = cart.findIndex((item) => item.id === product.id);
            if (itemIndex < 0) {
                cart.push(product);
            } else {
                cart[itemIndex].quantity++;
            }
        },
        removeFromCart({ cart }, productid) {
            const itemIndex = cart.findIndex((item) => item.id === productid);
            cart.splice(itemIndex, 1);
        },
        decreaseItem({ cart }, productid) {
            const itemIndex = cart.findIndex((item) => item.id === productid);
            cart[itemIndex].quantity--;
        },
        increaseItem({ cart }, productid) {
            const itemIndex = cart.findIndex((item) => item.id === productid);
            cart[itemIndex].quantity++;
        },
        changeView(state, newView) {
            state.view = newView;
        },
    },
};
